<template>
  <div class="container" v-if="show">
    <ul class="drop-menu" @click.stop>
      <li
        v-for="item in visibleItems"
        :key="item.path || item.name"
        :title="item.name"
        :class="{
          hover: true,
          active: isActive(item),
          pointer: !isActive(item)
        }"
        @click="selectItem(item)"
      >
        <span class="drop-item-text">{{item.name}}</span>
      </li>       
    </ul>
  </div>
</template>

<script>
export default {
  name: 'my-drop-item',
  props:['items','show'],
  emits: ['select'],
  computed: {
    visibleItems() {
      return (this.items || []).filter((item) => {
        if (item.show === undefined) return true
        return typeof item.show === 'function' ? item.show() : item.show
      })
    },
  },
  methods: {
    isActive(item) {
      if (!item.path) return false
      if (item.exact || item.path === '/') return this.$route.path === item.path
      return this.$route.path === item.path || this.$route.path.startsWith(`${item.path}/`)
    },
    selectItem(item) {
      if (item.path && this.$route.path !== item.path) {
        this.$router.push(item.path)
      }
      this.$emit('select', item)
    },
  },
};
</script>

<style scoped>

.container{
  margin-top: 4px;
  padding: 6px;
  background-color: rgb(243,244,246);
  border-radius: 5px;
}

.drop-menu{
  list-style-type: none;
}


li{
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 0 14px;
  border-radius: 5px;
  margin-top: 2px;
}

.drop-item-text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


.pointer{
  cursor: pointer;
}

.hover:hover:not(.active){
  background-color: rgba(207,207,208,1);
}

.active{

  background-color: rgba(79,70,229, 1);
  color: white ;
}
</style>
